/**
 * This file specifies the state of the application in response to Vendor Application actions
 */
import { fromJS } from 'immutable';
import { assign } from 'lodash';
import Constants from '../../constants';

const { Vendor } = Constants;

const initialState = fromJS({
  loading: false,
  error: null,
  vendorContactError: null,
  vendor: {},
  publicFilesUrls: {},
});

/**
 * Returns and sets the next state based on the action passed to it
 * @param {object} state state object that defaults to the initial state
 * @param {object} action action object containing action type and payload properties
 */
const vendorApplicationReducer = (state = initialState, action) => {
  const { vendor, publicFilesUrls, progressEvent, fileName } = action;

  switch (action.type) {
    case Vendor.CREATE_VENDOR_NETSUITE:
      return state.set('loading', true).set('error', null);
    case Vendor.CREATE_VENDOR_NETSUITE_ERROR:
      return state.set('loading', false).set('error', action.error.message);
    case Vendor.CREATE_VENDOR_NETSUITE_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .set('vendor', fromJS(vendor));
    case Vendor.CREATE_VENDOR_CONTACT:
      return state.set('loading', true).set('vendorContactError', null);
    case Vendor.CREATE_VENDOR_CONTACT_ERROR:
      return state
        .set('loading', false)
        .set('vendorContactError', action.error.message);
    case Vendor.CREATE_VENDOR_CONTACT_SUCCESS:
      return state
        .set('loading', false)
        .set('vendorContactError', null)
        .set('vendor', fromJS(vendor));
    case Vendor.GET_VENDOR:
      return state
        .set('loading', true)
        .set('error', null)
        .set('vendor', fromJS({}));
    case Vendor.GET_VENDOR_ERROR:
      return state.set('loading', false).set('error', action.error.message);
    case Vendor.GET_VENDOR_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .set('vendor', fromJS(vendor));
    case Vendor.GET_PUBLIC_FILES:
      return state.set('loading', true).set('error', null);
    case Vendor.GET_PUBLIC_FILES_SUCCESS:
      return state
        .set('loading', false)
        .set('publicFilesUrls', fromJS(publicFilesUrls));
    case Vendor.GET_PUBLIC_FILES_ERROR:
      return state.set('error', action.error.message);
    case Vendor.UPDATE_VENDOR:
      return state.set('loading', true).set('error', null);
    case Vendor.UPDATE_VENDOR_ERROR:
      return state.set('loading', false).set('error', action.error.message);
    case Vendor.UPDATE_VENDOR_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .set('vendor', fromJS(vendor));
    case Vendor.UPDATE_VENDOR_FILE_PROGRESS:
      return state.setIn(
        ['publicFilesUrls', fileName],
        assign(state.get('publicFilesUrls').toJS()[fileName], {
          progressEvent: {
            total: progressEvent.total,
            loaded: progressEvent.loaded,
            timeStamp: progressEvent.timeStamp,
          },
        }),
      );
    case Vendor.UPDATE_VENDOR_NETSUITE:
      return state.set('loading', true).set('error', null);
    case Vendor.UPDATE_VENDOR_NETSUITE_ERROR:
      return state.set('loading', false).set('error', action.error.message);
    case Vendor.UPDATE_VENDOR_NETSUITE_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .set('vendor', fromJS(vendor));
    case Vendor.UPDATE_VENDOR_CONTACT:
      return state.set('loading', true).set('vendorContactError', null);
    case Vendor.UPDATE_VENDOR_CONTACT_ERROR:
      return state
        .set('loading', false)
        .set('vendorContactError', action.error.message);
    case Vendor.UPDATE_VENDOR_CONTACT_SUCCESS:
      return state
        .set('loading', false)
        .set('vendorContactError', null)
        .set('vendor', fromJS(vendor));
    case Vendor.SUBMIT_VENDOR:
      return state.set('loading', true).set('error', null);
    case Vendor.SUBMIT_VENDOR_ERROR:
      return state.set('loading', false).set('error', action.error.message);
    case Vendor.SUBMIT_VENDOR_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .set('vendor', fromJS(vendor));
    case Vendor.REMOVE_VENDOR_CONTACT:
      return state.set('loading', true).set('vendorContactError', null);
    case Vendor.REMOVE_VENDOR_CONTACT_ERROR:
      return state
        .set('loading', false)
        .set('vendorContactError', action.error.message);
    case Vendor.REMOVE_VENDOR_CONTACT_SUCCESS:
      return state
        .set('loading', false)
        .set('vendorContactError', null)
        .set('vendor', fromJS(vendor));
    default:
      return state;
  }
};

export default vendorApplicationReducer;
